var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Actions_Operations_delete_16",
    "data-name": "Actions / Operations / delete / 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M9.167,13H1.833a.874.874,0,0,1-.917-.929V2.785H0V1.857H11v.928h-.917v9.285A.874.874,0,0,1,9.167,13ZM1.833,2.785v9.285H9.167V2.785Zm5.5,7.429H6.417V4.643h.917v5.571Zm-2.75,0H3.667V4.643h.917v5.571ZM7.334.928H3.666V0H7.334V.928Z",
    transform: "translate(2 1)",
    fill: "#d53d3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/deleteRed.897e0ffe884b343c9193c7e55399bf8f.svg";
export { ForwardRef as ReactComponent };